<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <div class="col-12 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle d-block">Lista</span>
        <h3 class="page-title d-inline">Usuários</h3>
        <d-button class="btn btn-success text-white float-right" @click="openFilter">Novo filtro</d-button>
      </div>
    </d-row>

    <!-- Default Light Table -->
    <d-row>
      <d-col md="3">
        <label>Filtro
          <small class="ml-3" v-if="filter.id" @click="editFilter"><i class="fas fa-edit"></i>Editar</small>
        </label>
        <d-select v-model="filter">
          <option :value="option" v-for="(option, index) in filters" :key="index">{{option.name}}</option>
        </d-select>
      </d-col>
      <d-col md="3">
        <label>Ordem:</label>
        <d-select v-model="pagination.order" :options="order"></d-select>
      </d-col>
      <d-col cols="auto">
        <label></label>
        <d-button @click="getList">Filtrar</d-button>
      </d-col>
      <d-col md="2" class="" >
        <label class="w-100">Login:</label>
        <d-button class="v-facebook-login" @click="openFacebookLogin" v-if="!authFBToken">
          <svg data-v-1531884d="" width="24" height="24" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="logo"><path d="M22.675 0h-21.35c-.732 0-1.325.593-1.325 1.325v21.351c0 .731.593 1.324 1.325 1.324h11.495v-9.294h-3.128v-3.622h3.128v-2.671c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.795.143v3.24l-1.918.001c-1.504 0-1.795.715-1.795 1.763v2.313h3.587l-.467 3.622h-3.12v9.293h6.116c.73 0 1.323-.593 1.323-1.325v-21.35c0-.732-.593-1.325-1.325-1.325z"></path></svg>
          Entrar
        </d-button>
        <d-button class="v-facebook-login" @click="logoutFacebook" v-else>
          Logout
        </d-button>
      </d-col>
    </d-row>
    <d-row>
      <d-col cols="12">
        <feed-list-items></feed-list-items>
      </d-col>
    </d-row>
    <feed-filter :title="filterTitle"/>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import { cloneDeep } from '_utils';
import Events from '_utils/events';
import Pagination from '_shared/Pagination.vue';
import FeedService from '_services/rest/modules/feed';
import FeedFilter from '../components/modal/FilterModal.vue';
import FeedListItems from '../components/FeedListItems.vue';
import { FILTER_MODEL, _EDIT_FILTER_, _OPEN_FILTER_MODAL_, _LOAD_FEED_ } from '../components/FeedModel';

export default {
  name: 'user-list',
  components: {
    FeedFilter,
    Pagination,
    FeedListItems,
  },
  data() {
    return {
      linkLogin: null,
      order: [
        { value: 'like_count', text: 'Like' },
        { value: 'comments_count', text: 'Comentários' },
        { value: 'strtotime', text: 'Data' },
      ],
      filter: cloneDeep(FILTER_MODEL),
      pagination: {
        take: 10,
        token: null,
        items: null,
        order: 'strtotime',
        status: false,
      },
      filterTitle: 'Novo Filtro',
    };
  },
  computed: {
    authFBToken() {
      const { authResponse } = this.$store.state.feed;
      if (authResponse) {
        return authResponse;
      }
      return false;
    },
    filters() {
      const { filterList } = this.$store.state.feed;
      if (filterList) {
        return filterList;
      }
      return false;
    },
  },
  methods: {
    ...mapActions([
      'logoutFB',
      'setToggle',
      'setFBToken',
      'activeAlert',
      'getFilterList',
      'updateFilterList',
    ]),
    getUrlLogin() {
      FeedService.getUrlLogin()
        .then(response => {
          this.linkLogin = response;
        })
        .catch(error => console.log('error', error));
    },
    openFacebookLogin() {
      window.open(this.linkLogin, '_self');
    },
    getFilters() {
      this.getFilterList();
    },
    getList() {
      setTimeout(() => {
        this.pagination.token = this.authFBToken.access_token;
        this.pagination.user_id = this.authFBToken.user_id;
        this.pagination.items = this.filter.items;
        FeedService.getList(this.pagination)
          .then(response => {
            Events.$emit(_LOAD_FEED_, response.data);
          })
          .catch(err => {
            if (err.status === 406) {
              this.activeAlert({ message: 'Sua autenticação falhou. Por favor, faça login no Facebook novamente', theme: 'danger' });
              this.openFacebookLogin();
            }
          });
      }, 50);
    },
    setFilterItems(type) {
      let index = 0;
      return this.filter.items.filter(item => {
        if (item.type === type) {
          // eslint-disable-next-line
          item.index = index++;
          return true;
        }
        return false;
      });
    },
    editFilter() {
      this.filterTitle = 'Editar filtro';
      setTimeout(() => {
        this.filter.users = this.setFilterItems('user');
        this.filter.hashtags = this.setFilterItems('hashtag');
        Events.$emit(_OPEN_FILTER_MODAL_, this.filter);
        this.setToggle({ type: 'feed_filter_modal', bool: true });
      }, 20);
    },
    openFilter() {
      this.filterTitle = 'Novo filtro';
      Events.$emit(_OPEN_FILTER_MODAL_, { ...FILTER_MODEL });
      this.setToggle({ type: 'feed_filter_modal', bool: true });
    },
    logoutFacebook() {
      this.logoutFB();
    },
  },
  mounted() {
    Events.$emit('sidebarVisible', false);
    Events.$on('update:pagination', () => {
      this.getList();
    });
    Events.$on(_EDIT_FILTER_, filter => {
      this.updateFilterList(filter);
      setTimeout(() => {
        this.filter = filter;
        this.getList();
      }, 50);
    });
    this.getFilters();
    this.getUrlLogin();
  },

};
</script>

<style lang="scss" scoped>
.v-facebook-login {
  height: 33px;
  /deep/ svg {
    margin-top: -2px;
    height: 100%;
  }
  /deep/ span {
    font-size: 12px;
  }
}

.col-auto {
  label {
    display: block;
    height: 22px;
  }
}
</style>
